import { Component, OnInit, Input } from '@angular/core'
import { environment } from 'environments/environment'
import { Organization } from 'app/models/organization'

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() public organization: Organization
  @Input() public ga?: {
    orgAction?: string,
    orgLabel?: string,
    solutionsAction?: string,
    solutionsLabel?: string,
    helpAction?: string,
    helpLabel?: string
  }

  public loginUrl: string

  public ngOnInit(): void {
    this.loginUrl = environment.mySeUrl
  }


  /**
   * return passed in Google Analytics (ga) value or null
   * if null the attribute should not be created on the element
   * @param attr (see possible keys from Input ga)
   * @return string | null
   */
  public gaAttr(attr: string): string {
    return this.ga && this.ga[attr] || null
  }
}
